export default function Tilt3DMulti() {
	return (
		<iframe
			src='/tilt3d/multi/index.html'
			style={{ width: '100%', height: '100vh', border: 'none' }}
		/>
	);
}
